


import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import Tab from '../Tab/index.vue';
import { Zone, Module } from '../../utils/api';
import { RenderMode } from '../ConfContainer/ConfContainer.models';
import TabSelect from '../TabSelect/index.vue';
import GridSelect from '../GridSelect/index.vue';
import VerticalSelect from '../VerticalSelect/index.vue';
import { SelectType } from '../SelectionPanel/SelectionPanel.models';

@Component({
  components: {
    TabSelect,
    Tab,
    GridSelect,
    VerticalSelect
  }
})
export default class SubzoneNavigation extends Vue {
  @Prop() activeSubzone!: Zone;
  @Prop() subzones!: Zone[];
  @Prop() selectType!: SelectType;

  // to make ts enums work in vue template
  private SelectType: typeof SelectType = SelectType;
  private RenderMode: typeof RenderMode = RenderMode;

  @Emit()
  private changeSubzone(subzoneID: string) {
    return subzoneID;
  }

  @Emit()
  private selectOption(option: Module) {
    return option;
  }
}
